import script from "./MarketNow.vue?vue&type=script&setup=true&lang=js"
export * from "./MarketNow.vue?vue&type=script&setup=true&lang=js"

import "./MarketNow.vue?vue&type=style&index=0&id=44b27ed6&lang=scss"

const __exports__ = script;

export default __exports__